export const salutationTypes = {
    None: '<None>',
    Mr: 'Mr',
    Mrs: 'Mrs',
    Ms: 'Ms',
    Miss: 'Miss',
    Dr: 'Dr',
    A_Prof : 'A/Prof', 
    Prof: 'Prof',
    Rev: 'Rev',
    Hon: 'Hon',
    Mx: 'Mx'
}

export const salutationOptions = [
    {
        text: salutationTypes.Mr,
        value: salutationTypes.Mr
    },
    {
        text: salutationTypes.Mrs,
        value: salutationTypes.Mrs
    },
    {
        text: salutationTypes.Ms,
        value: salutationTypes.Ms
    },
    {
        text: salutationTypes.Miss,
        value: salutationTypes.Miss
    },
    {
        text: salutationTypes.Dr,
        value: salutationTypes.Dr
    },
    {
        text: salutationTypes.A_Prof,
        value: salutationTypes.A_Prof
    },
    {
        text: salutationTypes.Prof,
        value: salutationTypes.Prof
    },
    {
        text: salutationTypes.Rev,
        value: salutationTypes.Rev
    },
    {
        text: salutationTypes.Hon,
        value: salutationTypes.Hon
    },
    {
        text: salutationTypes.Mx,
        value: salutationTypes.Mx
    }
]